import { perf } from './utils';

export class SignalQualityMonitor {

  private isInitialized = false;

  private firstTimeReal = NaN;
  private lastTimeReal = NaN;
  private firstTimestamp = NaN;
  private lastTimestamp = NaN;

  private frameDurationMin = Infinity;
  private frameDurationMax = -Infinity;
  private frameDurationsSum = 0;
  private frameCount = 0;
  private timeOffsetSum = 0;
  private maxTimeOffsetMs = 0;
  private frameLengthDeviationMs = 0;

  private bytesReceived = 0;
  private startTime = 0;

  private droppedFrames = 0;

  getMetrics() {
    const averageFrameDuration = this.frameDurationsSum / this.frameCount;
    const framerateTimestamp = 1000 / averageFrameDuration;
    const timeElapsed = this.lastTimeReal - this.firstTimeReal;
    const bitrate = (this.bytesReceived * 8) / (timeElapsed / 1000);

    return {
      firstTimeReal: this.firstTimeReal,
      lastTimeReal: this.lastTimeReal,
      firstTimestamp: this.firstTimestamp,
      lastTimestamp: this.lastTimestamp,
      frameCount: this.frameCount,
      frameDurationMin: this.frameDurationMin,
      frameDurationMax: this.frameDurationMax,
      maxTimeOffsetMs: this.maxTimeOffsetMs,
      frameLengthDeviationMs: this.frameLengthDeviationMs,
      framerateTimestamp,
      bitrate,
      droppedFrames: this.droppedFrames,
    };
  }

  onFrame(timestamp: number, payloadSize: number) {

    const timeNowMs = perf.now();
    const timestampMs = timestamp;

    if (!this.isInitialized) {
      this.isInitialized = true;
      this.firstTimeReal = timeNowMs;
      this.lastTimeReal = timeNowMs;
      this.firstTimestamp = timestampMs;
      this.lastTimestamp = timestampMs;
      this.startTime = timeNowMs;
      return;
    }

    const diffTimeReal = timeNowMs - this.lastTimeReal;
    const diffTimestamp = timestampMs - this.lastTimestamp;

    this.frameDurationMin = Math.min(this.frameDurationMin, diffTimestamp);
    this.frameDurationMax = Math.max(this.frameDurationMax, diffTimestamp);
    this.frameDurationsSum += diffTimestamp;
    this.frameCount += 1;

    const timeOffsetMs = Math.abs((timestampMs - this.firstTimestamp) - (timeNowMs - this.firstTimeReal));
    this.timeOffsetSum += timeOffsetMs;
    this.maxTimeOffsetMs = Math.max(this.maxTimeOffsetMs, timeOffsetMs);

    const frameLengthDiffMs = this.frameDurationMax - this.frameDurationMin;
    this.frameLengthDeviationMs = frameLengthDiffMs;

    this.lastTimeReal = timeNowMs;
    this.lastTimestamp = timestampMs;

    this.bytesReceived += payloadSize;
  }

  onFrameDropped() {
    this.droppedFrames += 1;
  }
}
